<template>
<div>
    <div class="mt-2">
        <v-btn text class="grey--text text--darken-1" @click="$router.push('/admin-articles')">
            <v-icon size="14px" color="grey darken-1" class="mr-3">fa-angle-left</v-icon>
            Back to Stuff Admin List
        </v-btn>
    </div>

    <v-row v-if="loaded">
        <v-col cols="12" sm="8">
            <v-card outlined>
                <v-card-text :class="($vuetify.breakpoint.xsOnly) ? 'pa-4' : 'px-8 py-4'">
                    <div class="subtitle-1 font-weight-medium primary--text mb-4">Edit stuff</div>

                    <!-- TYPE -->
                    <v-select
                        v-model="model.type"
                        :items="[{title: 'Article', id:'page'}, {title: 'Video', id:'video'}, {title: 'File uploaded', id:'file'}]"
                        item-text="title"
                        item-value="id"
                        append-icon="fa-angle-down accent--text"
                        outlined dense
                        label="Select the type">
                    </v-select>

                    <!-- TITLE -->
                    <v-text-field
                        v-model="model.title"
                        label="Title"
                        maxlength="200"
                        outlined dense
                        @keydown.enter="validate">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-tag fa-fw</v-icon>
                        </template>
                    </v-text-field>

                    <!-- SOURCE ICON -->
                    <v-select
                        v-if="model.type!='file'"
                        v-model="model.sourceIcon"
                        :items="[{title: 'Person', id:'person'}, {title: 'Media', id:'media'}]"
                        item-text="title"
                        item-value="id"
                        append-icon="fa-angle-down accent--text"
                        outlined dense
                        label="Select the author reference">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-mortar-pestle fa-fw</v-icon>
                        </template>
                    </v-select>

                    <!-- TITLE -->
                    <v-text-field
                        v-model="model.author"
                        :label="(model.sourceIcon=='person' || model.sourceIcon=='' || model.type=='file') ? 'Author' : 'Media name reference'"
                        maxlength="200"
                        outlined dense
                        @keydown.enter="validate">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small v-if="model.sourceIcon==''">fa-angle-right fa-fw</v-icon>
                            <v-icon color="info" class="mt-1 mr-1" small v-if="model.sourceIcon=='person'">fa-user fa-fw</v-icon>
                            <v-icon color="info" class="mt-1 mr-1" small v-if="model.sourceIcon=='media'">fa-file fa-fw</v-icon>
                            <v-icon color="info" class="mt-1 mr-1" small v-if="model.type=='file'">fa-file-download fa-fw</v-icon>
                        </template>
                    </v-text-field>

                    <!-- URL -->
                    <v-text-field
                        v-if="model.type!='file'"
                        v-model="model.url"
                        label="External URL"
                        maxlength="600"
                        outlined dense
                        @keydown.enter="validate">
                        <template v-slot:prepend>
                            <v-icon color="info" class="mt-1 mr-1" small>fa-link fa-fw</v-icon>
                        </template>
                    </v-text-field>

                    <!-- BUTTON -->
                    <div class="text-end mt-4">
                        <v-btn 
                            depressed 
                            class="accent" 
                            @click="validate" 
                            :disabled="sending">Update stuff</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Articles from '@/firebase/articles'

export default {
    data: () => ({
        loaded: false,
        sending: false,
        model: {
            type: '',
            title: '',
            author: '',
            url: '',
            sourceIcon: ''
        }
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Articles.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.model = response.doc.data();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        validate() {
            if (this.model.type == '') {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a type.'});
                return;
            }

            if (this.validateIsEmpty(this.model.title)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a title.'});
                return;
            }


            if (this.model.sourceIcon == '' && this.model.type != 'file') {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to select a source reference.'});
                return;
            }

            if (this.validateIsEmpty(this.model.author)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a auhtor.'});
                return;
            }

            if (this.validateIsEmpty(this.model.url) && this.model.type != 'file') {
                this.$store.dispatch('setSnack', {kind:'error', text:'You have to set a url.'});
                return;
            }

            this.add();
        },
        add(final) {
            this.sending = true;

            Articles.save(this.$route.params.id, this.model)
                    .then(response => {
                        if (response === true) {
                            this.$router.push('/admin-articles');
                            this.$store.dispatch('setSnack', {kind:'success', text:'The stuff has saved.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>